<div class="new-add-payment">
    <div class="payment-heading">
        <img (click)="closeDialog('close')" src="../../assets/images/new-close.svg" alt="Close" />
    </div>
    <div class="payment-body">
        <img src="../../../../assets/images/payment-method-icon.svg" alt="Payment Method" />
        <h4>Set Default Payment Method!</h4>
        <p *ngIf="config.data?.role === userRole.DRIVER || config.data?.role === userRole.GROUP_USER">A default payment method is required to create<br /> a recurring booking.</p>
        <p
            *ngIf="config.data?.role === userRole.SUPER_ADMIN || config.data?.role === userRole.PARKING_MANAGER || config.data?.role === userRole.PARKING_OWNER">
            This <span>{{bookingFor}}</span> does not have a default payment method.</p>
        <div class="confirm-booking-btn">
            <p-button *ngIf="config.data?.role === userRole.SUPER_ADMIN || config.data?.role === userRole.PARKING_MANAGER || config.data?.role === userRole.PARKING_OWNER" (onClick)="addPaymentMethod()" styleClass="p-button" label="Add Payment Method">
            </p-button>
            <p-button *ngIf="config.data?.role === userRole.DRIVER || config.data?.role === userRole.GROUP_USER" (onClick)="addPaymentMethod()" styleClass="p-button" label="Add Payment Method">
            </p-button>
            <p-button
                *ngIf="config.data?.role === userRole.SUPER_ADMIN || config.data?.role === userRole.PARKING_MANAGER || config.data?.role === userRole.PARKING_OWNER"
                (onClick)="closeDialog('skip')" label="Skip" styleClass="p-button p-button-outlined ml-3"> </p-button>
        </div>
    </div>

</div>